// extracted by mini-css-extract-plugin
module.exports = {"container":"Trending_container__38vAo"};